var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{attrs:{"src":require('@/assets/bio-image.jpg')}}),_vm._v(" Hi im srikanth wanna play? ")])
}
var staticRenderFns = []

export { render, staticRenderFns }